interface ClientUpdateBannerProps {
  visible: boolean;
  onRefresh?: () => void;
}

export function ClientUpdateBanner({ visible, onRefresh }: ClientUpdateBannerProps) {
  if (!visible) {
    return null;
  }

  return (
    <div className="client-update-banner" role="status" aria-live="polite">
      <div className="client-update-banner__message">
        <strong>A new version of KnotFin is available.</strong>
        <span>Refresh to get the latest updates.</span>
      </div>
      <button
        type="button"
        className="client-update-banner__refresh"
        onClick={onRefresh ?? (() => window.location.reload())}
      >
        Refresh
      </button>
    </div>
  );
}
